module.exports = __webpack_public_path__ + "media/images/emblems/Troinex-coat_of_arms-f9ab1175861ba6101289b7547aaf417b.svg";